<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addIdentityClick" v-if="auth_control.have_add_auth">新增身份</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="title"
		      label="管理员身份"
		      align="center"
        >
		    </el-table-column>

		    <el-table-column
		      label="管理模块"
		      align="center"
        >
          <template slot-scope="scope">
          	<div>{{scope.row.rules_name.join('/')}}</div>
          </template>
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="160"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editIdentityClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
         	    <span class="opration-item" @click="deleteIdentityClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
		    :total="total"
	      :page_size="page_size"
		    @size-change="handelPagesizeChange"
		    @page-change="handlePageChange"
		  ></common-pagination>
		  <IdentitylistDialog
		    :dialogVisible="dialogVisible"
		    :dialogTitle="dialogTitle"
		    :dialogType="dialogType"
		    :handle_row="handle_row"
		    @close="handleDialogClose"
		    @cancel="handelDialogCancel"
		  >
		  </IdentitylistDialog>
    </div>
  </div>
</template>

<script>
import { identityOf } from '@/api/auth';
import CommonPagination from '@/components/CommonPagination';
import IdentitylistDialog from './components/IdentitylistDialog';
import { mapState } from 'vuex';

export default {
  name: 'identitymanage',
  data() {
  	return {
      tableData: [],
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  		dialogVisible: false,
  		dialogTitle: '',
  		dialogType: '',
  		handle_row: {},
      auth_control: {
        have_add_auth: false,
        have_edit_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
  	}
  },
  components: {
  	CommonPagination,
  	IdentitylistDialog
  },
  computed: {
    ...mapState(['operationList'])
  },
  mounted() {
  	this.getIdentityList();
    this.handleThreeRules();
  },
  methods: {
  	async getIdentityList() {
      let postData = {
         page_index: this.page_index,
         page_size: this.page_size,
      }
      const { data, status } = await identityOf(postData);
      if ( status !== 200) return
      this.tableData = data.char;
      this.total = data.total_data;
  	},
  	addIdentityClick() {
      this.dialogType = 'add';
      this.dialogTitle = '新增身份';
      this.dialogVisible =  true;
  	},
  	editIdentityClick(row) {
  		this.handle_row= JSON.parse(JSON.stringify(row));
  		this.dialogType = 'edit';
  		this.dialogTitle = '编辑身份';
  		this.dialogVisible = true;
  	},
  	deleteIdentityClick(row) {
  		this.handle_row = JSON.parse(JSON.stringify(row));
  		this.dialogType = 'delete';
  		this.dialogTitle = '删除身份';
  		this.dialogVisible = true;
  	},
  	handelPagesizeChange(size) {
  		this.page_size = size;
  		this.getIdentityList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this.getIdentityList();
  	},
  	handleDialogClose() {
  		this.dialogVisible = false;
  		this.handle_row = {};
  		this.getIdentityList();
  	},
  	handelDialogCancel() {
  		this.dialogVisible = false;
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('新增') !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf('编辑') !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
	margin-top: 30px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item {
			cursor: pointer;
		}
	}
}
</style>
